package ui.components.atoms

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.*

import org.w3c.dom.HTMLElement

@Composable
fun FloatingActionButton(
    icon: String,
    onClick: () -> Unit,
    color: String = "#8b5cf6"
) {
    Button(
        attrs = {
            onClick { onClick() }
            style {
                position(Position.Fixed)
                bottom(20.px)
                right(20.px)
                width(56.px)
                height(56.px)
                borderRadius(50.percent)
                backgroundColor(Color(color))
                color(Color.white)
                border(0.px)
                fontSize(24.px)
                cursor("pointer")
                property("box-shadow", "0 4px 12px rgba(0,0,0,0.15)")
                property("z-index", "1000")
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                property("transition", "transform 0.2s ease")
            }
            // Simplified hover - avoiding direct DOM manipulation
            onMouseEnter { }
            onMouseLeave { }
        }
    ) {
        Text(icon)
    }
}